/*
* @Description: 提货司机管理 查看弹出层
* @Author: ma.cq
* @Date: 2018-10-18 10:47:44
* @LastEditors: ma.cq
* @LastEditTime: 2018-10-18 10:47:44
*/
<template>
  <el-dialog title="查看" :visible.sync="visible" @close="handleClose" width="800px">
    <el-form label-width="100px">
      <el-form-item label="司机姓名">
        <el-row class="text">{{form.driverName}}</el-row>
      </el-form-item>
      <el-form-item label="手机">
        <el-row class="text">{{form.phone}}</el-row>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-row class="text">{{form.identityCard}}</el-row>
      </el-form-item>
      <el-form-item v-if="form.status === 5" label="身份证照片">
        <img-view :src="form.idCardObverse" :transfrom="true" class="img-view"></img-view>
        <img-view :src="form.idCardPositive" :transfrom="true" class="img-view"></img-view>
      </el-form-item>
      <el-form-item label="信誉记录">
        <el-table
          :data="trustData"
          style="width: 100%"
          tooltip-effect="light">
          <el-table-column
            prop="time"
            label="时间"
            width="180"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="change"
            label="增加/减少"
            width="180"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          :page-size="pageSize"
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import ImgView from '@/components/imgView'

export default {
  name: 'checkDialog',
  components: { ImgView },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      trustData: [],
      pageSize: 1,
      pageNo: 1,
      total: 2,
      visible: this.show,
      form: {},
      formLabelWidth: '100px'
    }
  },
  methods: {
    ...mapActions(['getDriver', 'getTrustPoint']),
    handleClose () {
      this.$emit('update:show', false)
    },
    // 分页跳转
    handleCurrentChange (val) {
      // this.getAdContentList({ pageNo: val })
      this.getTrustPoint({ id: this.formData.id, pageNo: val }).then((data) => {
        this.trustData = data.list
        this.total = data.total
        this.pageSize = data.pageSize
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = { ...this.formData }
        this.getTrustPoint({ id: this.formData.id }).then((data) => {
          this.trustData = data.list
          this.total = data.total
          this.pageSize = data.pageSize
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .text {
    color: $primary-font-color-light;
    font-size: 12px;
  }
  .img-view {
    width: 150px;
    height: 150px;
    margin-right: 10px;
    float: left;
  }
  .tip {
    color: #ccc;
    font-size: 12px;
  }
  .pagination{
    text-align: center;
  }
</style>
